import React from "react";
import background from "../../assets/images/updated-background.png";
import "./login.scss";
import logo from "../../assets/svgs/ArcSpan-Logo2.svg";
import Login from "../../components/login";
import "../../utilities/variables.scss";

function LoginPage() {
	return (
		<div
			className="loginPage"
			style={{
				backgroundImage: `url(${background})`,
				backgroundRepeat: "no-repeat",
				backgroundSize: "cover",
				backgroundPosition: "center",
				height: "100vh",
			}}
		>
			<div className="login-header container">
				<img
					className="login-logo"
					src={logo}
				/>
			</div>
			<div className="login-container container">
				<div className="left-container">
					<div className="text strong">
						Take control of your <div>Audience Monetization</div>
					</div>
				</div>
				<div className="right-container">
					<Login />
				</div>
			</div>
		</div>
	);
}

export default LoginPage;
